const state = {
  isOnline: true,
  isInitialized: false
}

const getters = {
  getIsOnline: (state) => state.isOnline
}

const mutations = {
  SET_IS_ONLINE: (state, value) => state.isOnline = value,
  SET_INITIALIZED: (state, value) => state.isInitialized = value
}

const actions = {
  listenNetworkStatus({ commit, rootGetters, state }) {
    const firebase = rootGetters.getFirebase;
    firebase.database().ref('.info/connected').on('value', (snapshot) => {
      if (state.isInitialized) {
        commit('SET_IS_ONLINE', snapshot.val())
      }

      commit('SET_INITIALIZED', true)
    })  
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}